import { fetchFooter } from 'redux/modules/taxonomy/actions';
import { getIsFooterLoaded } from 'redux/modules/taxonomy/selectors';

export const footerFetcher = () => (dispatch, getState) =>
  getIsFooterLoaded(getState()) ? Promise.resolve() : dispatch(fetchFooter());
